import BaseStore from 'customer-flows/stores/base-store'
import { context } from 'customer-flows/utils/core'
import { type Awaitable } from 'customer-flows/utils/core'
import type IntlService from 'ember-intl/services/intl'
import { service } from '@ember/service'
export default class ActivityStoreClass extends BaseStore {
  @service intl: IntlService

  @context('program') program: Awaitable<ActivityProgramType>

  get activity(): Activity | undefined {
    return this.program.value?.activity
  }

  get id(): string | undefined {
    return this.activity?.id
  }

  get name(): string | undefined {
    return this.activity?.name
  }

  get type(): string | undefined {
    return this.activity?.type
  }

  get tickets(): Ticket[] {
    return this.activity?.tickets ?? []
  }

  get title(): string | undefined {
    return this.activity?.name
  }

  get description(): string | undefined {
    return this.activity?.description
  }

  get images(): string[] | undefined {
    return this.activity?.imageUrls
  }

  get isRental(): boolean | undefined {
    return this.activity?.type === 'RENTAL'
  }

  get isActivity(): boolean | undefined {
    return this.activity?.type === 'ACTIVITY'
  }

  get minimumBookingBannerText(): string | undefined {
    return this.activity?.minimumBookingBannerText ?? this.intl.t('booking.time-picker.min-tickets.default-message')
  }

  get ticketPickerHeaderKey(): string {
    return this.isRental ? 'booking.resource-options.rentals-header' : 'booking.resource-options.activities-header'
  }

  get timePickerHeaderKey(): string {
    return this.isRental ? 'booking.time-picker.rentals-header' : 'booking.time-picker.activities-header'
  }

  get ticketPriceTextKey(): string {
    return this.isRental ? 'ticket-picker.ticket-price-text.rental' : 'ticket-picker.ticket-price-text.activity'
  }

  get reviewCount(): number {
    return this.activity?.reviewMeta?.count ?? 0
  }

  get averageRating(): number | undefined {
    const avgRating = this.activity?.reviewMeta?.avgRating
    return avgRating !== undefined && avgRating !== null ? Number(avgRating) : undefined
  }

  get qualifiesForReviews(): boolean {
    return (this.averageRating ?? 0) >= 4.0
  }

  get topReviews(): Review[] {
    return this.activity?.reviews?.entries ?? []
  }
}

declare global {
  export type ActivityStore = ActivityStoreClass
  export interface StoreRegistry {
    activity: ActivityStore
  }
}
